<template>
  <div class="flex bg-black md:h-[300px] text-white">
    <div class="container mx-auto md:flex justify-between px-8 md:px-0 py-10">
      <section class="md:flex md:gap-x-20 md:text-xl mb-10">
        <div class="mb-6">
          <router-link to="/" class="flex items-center md:mb-2">
            <img src="@/assets/white-logo.png" alt="INFLUME" class="object-contain mr-2 w-[50px] h-[50px]">
            <h1 class="text-xl font-bold">INFLUME</h1>
          </router-link>
          <span class="text-sm md:text-base">© Copyright 2023 INFLUME.<br/> All Rights Reserved.</span>
        </div>
        <div class="mb-6">
          <h3 class="font-bold mb-2 md:mb-6">About</h3>
          <a class="block mb-2 md:mb-4" href="/#Influencer" @click.prevent="scrollToSection('#Influencer')">Influencer</a>
          <a href="/#Business" @click.prevent="scrollToSection('#Business')">Business</a>
        </div>
        <div class="mb-6">
          <h3 class="font-bold mb-2 md:mb-6">Join Now</h3>
          <div class="mb-2 md:mb-4 cursor-pointer" @click="$emit('signUp', ROLE.Influencer)">Influencer</div>
          <div class="cursor-pointer" @click="$emit('signUp', ROLE.Business)">Business</div>
        </div>
        <div class="">
          <h3 class="font-bold mb-2 md:mb-6">FAQ</h3>
          <div class="mb-2 md:mb-4">Terms</div>
          <div>Privacy Policy</div>
        </div>
      </section>
      <section class="text-xl flex">
        <div class="border rounded-full w-[40px] h-[40px] flex items-center justify-center hover:bg-white hover:text-black mr-4">
          <font-awesome-icon :icon="['far', 'envelope']" />
        </div>
        <div class="border rounded-full w-[40px] h-[40px] flex items-center justify-center hover:bg-white hover:text-black mr-4">
          <font-awesome-icon :icon="['fab', 'linkedin']" />
        </div>
        <div class="border rounded-full w-[40px] h-[40px] flex items-center justify-center hover:bg-white hover:text-black mr-4">
          <font-awesome-icon :icon="['fab', 'instagram']" />
        </div>
        <div class="border rounded-full w-[40px] h-[40px] flex items-center justify-center hover:bg-white text-white hover:text-black">
          <font-awesome-icon :icon="['fab', 'square-facebook']" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ROLE } from '@/data/default'
export default {
  data() {
    return {
      ROLE,
    }
  },
  methods: {
    scrollToSection(selector) {
      this.$scrollTo(selector, 10, { offset: -50 })
    },
  }
}
</script>
